
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { OperationInfo } from '@/types';

@Component
export default class LeadOpType extends Vue {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;

  get leadOpType() {
    return this.operationInfo?.opType;
  }

  get opTypeLong(): string | null {
    switch (this.leadOpType) {
      case '110':
        return '110%';

      case '50':
        return 'STD/50%';

      default:
        break;
    }

    return null;
  }
}
